import axios from "axios";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
// import { AuthContext } from "../../context/AuthContext";
import "./login.scss";

const Login = () => {
  const [credentials, setCredentials] = useState({
    username: undefined,
    password: undefined,
  });

  const { loading, error, dispatch } = useContext(AuthContext);
  console.log("error=>", error);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handleClick = async (e) => {
    e.preventDefault();
    dispatch({ type: "LOGIN_START" });
    try {
      const res = await axios.post(
        // "/auth/login",
        `https://dummy-app-link.herokuapp.com/api/auth/login/${credentials.username}/${credentials.password}`,  
        // { credentials }
      );
      // console.log("res.data=>", res.data);
      // console.log("res.data=>", res);

      // if (1 == 1) {
        if (res.data.isAdmin) {
          dispatch({ type: "LOGIN_SUCCESS", payload: res.data.details });

        // dispatch({
        //   type: "LOGIN_SUCCESS",
        //   payload: {
        //     city: "karachi",
        //     country: "pakistan",
        //     createdAt: "2022-07-18T10:46:34.029Z",
        //     email: "daniyal@fleekbiz.com",
        //     phone: "03128793647",
        //     updatedAt: "2022-07-18T10:46:34.029Z",
        //     username: "admin",
        //     __v: 0,
        //     _id: "62d53a0a618eed1decf040bb",
        //   },
        // });


        navigate("/");
      } else {
        dispatch({
          type: "LOGIN_FAILURE",
          payload: { message: "You are not allowed!" },
        });
      }
    } catch (err) {
      dispatch({ type: "LOGIN_FAILURE", payload: err.response.data });
    }
  };

  return (
    <div className="login">
      <div className="lContainer">
        <img src="https://bookmepk.s3.eu-central-1.amazonaws.com/static/custom/V3/images/New-Logo---Bookme.png" />

        <br />
        <br />

        <input
          type="text"
          placeholder="admin"
          id="username"
          onChange={handleChange}
          className="lInput"
          // defaultValue="admin"
        />
        <input
          type="password"
          placeholder="admin"
          id="password"
          onChange={handleChange}
          className="lInput"
          // defaultValue="admin"
        />

        <button disabled={loading} onClick={handleClick} className="lButton">
          Login
        </button>

        {error && (
          <span style={{ color: "rgb(236 0 47)", marginTop:5 }}>{error.message}</span>
        )}
        {/* <br/> */}
      </div>
    </div>
  );
};

export default Login;
